import React, { Component } from 'react';
import { connect } from 'react-redux';
import DateTime from '_class/DateTime';
import User from '_class/User';

import { getScheduleItem, updateLessonInList } from 'actions/schedule';
import { deleteReportedAttendance, getAbsenceReasons, getAttendence, getForecast } from 'actions/absence';

import Modal from 'containers/Modals/Modal';
import AttendanceHistory from 'containers/Lesson/Partials/AttendanceHistory';
import ReportHistory from 'containers/Lesson/Partials/ReportHistory';

import { Spinner } from 'UI';
import { Checkbox, Button, ButtonGroup, Table, Icon, translate } from '@haldor/ui';
import DisplayName from 'components/Presentation/DisplayName';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

// This component contains temporary functionality for handling reporting absence with "Other activity"
// The full implementation will be done in a later release


class UserAbsence extends Component {

	constructor(props) {
		super(props);

		this.state = {
			selectedStudent: null,
			loading: true,
			submitting: false,
			reported: props.schedule.attendanceReported != null,
			values: [],
		};
	}

	setStudentValue = (student, type, valid = null, lateDuration = null, absenceReasonId = null) => {
		return new Promise((resolve) => {
			let values = JSON.parse(JSON.stringify(this.state.values));
			let foundExisting = this.state.values.findIndex((value) => {
				return value.user.userId == student.userId;
			});

			if (foundExisting > -1) {
				values[foundExisting].type = type;

				if (valid != null) {
					values[foundExisting].valid = valid;
				} else {
					values[foundExisting].valid = type.indexOf('VALID') == 0;
				}

				if (lateDuration != null) {
					values[foundExisting].lateDuration = lateDuration;
				} else {
					values[foundExisting].lateDuration = '';
				}
				if (absenceReasonId != null) {
					values[foundExisting].absenceReason = new Object({ id: absenceReasonId });
				}
				if (type == 'PRESENT') {
					values[foundExisting].absenceReason = null;
				}
			} else {
				values.push({
					user: {
						userId: student.userId,
					},
					valid: valid != null ? valid : type.indexOf('VALID') == 0,
					type: type,
					lateDuration: lateDuration,
					absenceRecordId: null,
					absenceReason: { id: absenceReasonId },
				});
			}
			this.setState({ values }, () => {
				resolve(1);
			});
		})
	}
	setStudentValueOtherActivity = (student, type, valid = null, lateDuration = null, absenceReasonId = null) => {
		return new Promise((resolve) => {
			let values = JSON.parse(JSON.stringify(this.state.values));
			let foundExisting = this.state.values.findIndex((value) => {
				return value.user.userId == student.userId;
			});

			if (foundExisting > -1) {
				// if (type.indexOf('OTHER_ACTIVITY') == 0) {
				// 	if (values[foundExisting].type == 'OTHER_ACTIVITY_PARTIAL') {
				// 		type = 'OTHER_ACTIVITY_PARTIAL';
				// 	}
				// }

				values[foundExisting].type = type;

				if (valid != null) {
					values[foundExisting].valid = valid;
				} else {
					values[foundExisting].valid = type.indexOf('VALID') == 0;
				}

				if (lateDuration != null) {
					values[foundExisting].lateDuration = lateDuration;
				} else {
					values[foundExisting].lateDuration = '';
				}
				if (absenceReasonId != null && absenceReasonId > 0) {
					values[foundExisting].absenceReason = new Object({ id: absenceReasonId });
				}
				if (type == 'PRESENT') {
					values[foundExisting].absenceReason = null;
				}
			} else {
				values.push({
					user: {
						userId: student.userId,
					},
					valid: valid != null ? valid : type.indexOf('VALID') == 0,
					type: type,
					lateDuration: lateDuration,
					absenceRecordId: null,
					absenceReason: { id: absenceReasonId },
				});
			}
			this.setState({ values }, () => {
				resolve(1);
			});
		})
	}

	getStudentValue = (student) => {
		let foundExisting = this.state.values.findIndex((value) => {
			return value.user.userId == student.userId;
		});

		if (foundExisting > -1) {
			return this.state.values[foundExisting];
		}

		return null;
	}

	componentDidMount = async () => {
		if (this.props.schedule.attendanceReported != null) {
			// This lesson has attendence
			await this.props.getAttendence(this.props.schedule.id);
		} else {
			this.props.getAttendence(this.props.schedule.id);
			await this.props.getForecast(this.props.schedule.id);
		}
		if (this.props.availableServices.attendanceAbsenceReasons) {
			await this.props.getAbsenceReasons();
		}
		this.setValues();
	}

	setValues = () => {
		let items = this.props.forecast;
		let values = [];
		if (this.props.schedule.attendanceReported) {
			items = this.props.attendance;
		}

		if (items == null) {
			this.setState({ loading: false });
			return true;
		}

		let students = [];
		items.forEach((item) => {
			item.validAbsent = item.type == "VALID_ABSENCE" || item.type == "VALID_LATE";
			item.absenceReason = item.absenceReason || null;

			// if item.user is not in students, add it
			if (students.findIndex(student => student.userId == item.user.userId) == -1) {
				students.push(item.user);
			}
		});

		students.forEach(async (student) => {
			const studentItems = items.filter(item => item.user.userId == student.userId && item.status != 'Deleted');
			let value = {
				user: {
					userId: student.userId,
				},
				valid: false,
				type: 'PRESENT',
				lateDuration: '',
				absenceRecordId: null,
				id: 0,
				absenceReason: null,
			};

			let hasInvalid = false;
			let hasValid = false;
			let hasLate = false;
			let hasOtherActivity = false;
			let lateDuration = 0;

			studentItems.forEach((item) => {
				if (item.type.indexOf('VALID') == 0) {
					hasValid = true;
				}

				if (item.type.indexOf('INVALID') == 0) {
					hasInvalid = true;
				}
				if (item.type.indexOf('OTHER_ACTIVITY') == 0) {
					hasOtherActivity = true;
				}

				if (item.type.indexOf('LATE') > -1 || item.type.indexOf('PARTIAL') > -1) {
					hasLate = true;
				}

				if (item.lateDuration != null) {
					lateDuration += item.lateDuration;
				}

				value.id = item.id;

				if (item.absenceRecordId != null) {
					value.absenceRecordId = item.absenceRecordId;
				}
				if (item.absenceReason != null) {
					value.absenceReason = item.absenceReason;
				}
			});

			let type = 'PRESENT';
			if (hasValid || hasInvalid) {
				type = 'ABSENCE';
			}

			if (hasLate) {
				type = 'LATE';
			}

			if (hasInvalid && hasValid) {
				value.type = 'INVALID_' + type;
				value.valid = false;
				values.push(value);
				return true;
			}

			if (hasLate) {
				if (hasValid) {
					value.type = 'VALID_' + type;
					value.valid = true;
					value.lateDuration = lateDuration + '';
				} else if (hasInvalid) {
					value.type = 'INVALID_' + type;
					value.valid = false;
					value.lateDuration = lateDuration + '';
				}
				else {
					value.type = 'OTHER_ACTIVITY_PARTIAL';
					value.lateDuration = lateDuration + '';
				}

				values.push(value);
				return true;
			}

			if (hasValid) {
				value.type = 'VALID_' + type;
				value.valid = true;

				values.push(value);
				return true;
			}

			if (hasInvalid) {
				value.type = 'INVALID_' + type;
				value.valid = false;
				values.push(value);
				return true;
			}
			if (hasOtherActivity) {
				value.type = 'OTHER_ACTIVITY';
				value.valid = true;
				values.push(value);
				return true;
			}

			value.type = 'PRESENT';
			values.push(value);
		});

		this.setState({ values, loading: false });
	}

	onSubmit = () => {
		if (this.props.onSubmit) {
			this.setState({ submitting: true });
			this.props.onSubmit(this.state.values).then(() => {
				this.setState({ submitting: false });
			});
		}
	}

	getReportedBy = (item) => {
		if (item.reportedBy != null && item.reportedBy.firstName != null) {
			const reportedBy = new User(item.reportedBy);
			return reportedBy.getName()
		}

		if (item.reportedBy != null) {
			if (item.reportedBy.userId == 'TrackAttendance') {
				return this.props.translate('system');
			}

			if (item.reportedBy != '') {
				return this.props.translate('Guardian')
			}
		}

		return null;
	}

	renderUserAbsentActions = (student) => {
		let status = this.getStudentValue(student).type;
		let prefix = 'INVALID_';

		if (status.indexOf('VALID') == 0) {
			prefix = 'VALID_';
		}

		return (
			<td>
				<ButtonGroup>
					{status == 'PRESENT' || status == 'VALID_PRESENT' ?
						<Button
							onClick={e => this.setStudentValue(student, 'PRESENT')}
							style={{ backgroundColor: '#4baf4d', borderColor: '#4baf4d' }}
						>
							{this.props.translate('present')}
						</Button>
						:
						<Button type="secondary" onClick={e => this.setStudentValue(student, 'PRESENT')}>
							{this.props.translate('present')}
						</Button>
					}

					{status == 'INVALID_ABSENCE' || status == 'VALID_ABSENCE' ?
						<Button
							onClick={e => this.setStudentValue(student, prefix + 'ABSENCE')}
							style={{ backgroundColor: '#df2d2e', borderColor: '#df2d2e' }}
						>
							{this.props.translate('absent-whole')}
						</Button>
						:
						<Button type="secondary" onClick={e => this.setStudentValue(student, prefix + 'ABSENCE')}>
							{this.props.translate('absent-whole')}
						</Button>
					}

					{status == 'INVALID_LATE' || status == 'VALID_LATE' ?
						<Button
							onClick={e => this.setStudentValue(student, prefix + 'LATE')}
							style={{ backgroundColor: '#f38234', borderColor: '#f38234' }}
						>
							{this.props.translate('late-partly')}
						</Button>
						:
						<Button type="secondary" onClick={e => this.setStudentValue(student, prefix + 'LATE')}>
							{this.props.translate('late-partly')}
						</Button>
					}
				</ButtonGroup>
			</td>
		);
	}
	renderUserAbsentActionsOtherActivity = (student) => {
		let status = this.getStudentValue(student).type;
		let prefix = 'INVALID_';
		let suffix = '_ABSENCE';

		if (status.indexOf('VALID') == 0) {
			prefix = 'VALID_';
		}
		if (status.indexOf('_LATE') > -1) {
			suffix = '_LATE';
		}
		else if (status.indexOf('OTHER_ACTIVITY') == 0) {
			suffix = '';
			if (status.indexOf('PARTIAL') > -1) {
				suffix = '_PARTIAL';
			}
		}

		return (
			<>
				<td style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>
					{status == 'PRESENT' || status == 'VALID_PRESENT' ?
						<Button
							onClick={e => this.setStudentValueOtherActivity(student, 'PRESENT')}
							style={{ backgroundColor: '#4baf4d', borderColor: '#4baf4d' }}
						>
							{this.props.translate('present')}
						</Button>
						:
						<Button type="secondary" onClick={e => this.setStudentValueOtherActivity(student, 'PRESENT')}>
							{this.props.translate('present')}
						</Button>
					}
				</td>
				<td style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>
					<ButtonGroup>
						{status == 'OTHER_ACTIVITY' || status == 'OTHER_ACTIVITY_PARTIAL' ?
							<Button
								onClick={e => this.setStudentValueOtherActivity(student, status)}
								style={{ backgroundColor: '#f38234', borderColor: '#f38234' }}
							>
								{this.props.translate('OTHER_ACTIVITY')}
							</Button>
							:
							<Button type="secondary" onClick={e => this.setStudentValueOtherActivity(student, 'OTHER_ACTIVITY' + (suffix == "_ABSENCE" ? '' : '_PARTIAL'))}>
								{this.props.translate('OTHER_ACTIVITY')}
							</Button>
						}
						{status == 'VALID_ABSENCE' || status == 'VALID_LATE' ?
							<Button
								onClick={e => this.setStudentValueOtherActivity(student, status)}
								style={{ backgroundColor: '#f38234', borderColor: '#f38234' }}
							>
								{this.props.translate('Valid')}
							</Button>
							:
							<Button type="secondary" onClick={e => this.setStudentValueOtherActivity(student, 'VALID' + (suffix == '' || suffix == '_ABSENCE' ? '_ABSENCE' : '_LATE'))}>
								{this.props.translate('Valid')}
							</Button>
						}
						{status == 'INVALID_ABSENCE' || status == 'INVALID_LATE' ?
							<Button
								onClick={e => this.setStudentValueOtherActivity(student, status)}
								style={{ backgroundColor: '#df2d2e', borderColor: '#df2d2e' }}
							>
								{this.props.translate('Invalid')}
							</Button>
							:
							<Button type="secondary" onClick={e => this.setStudentValueOtherActivity(student, 'INVALID' + (suffix == '' || suffix == '_ABSENCE' ? '_ABSENCE' : '_LATE'))}>
								{this.props.translate('Invalid')}
							</Button>
						}
					</ButtonGroup>
				</td>
			</>
		);
	}
	onMinutesChange = (minutes, student) => {
		minutes = minutes.replace(/[^\d]/, '');
		const userValue = this.getStudentValue(student);

		if (parseInt(minutes) !== 0) {
			if (parseInt(minutes) > this.props.schedule.length) {
				this.setStudentValue(student, userValue.type, null, this.props.schedule.length);
			} else {
				this.setStudentValue(student, userValue.type, null, parseInt(minutes));
			}
		}
	}

	onChangeValidAbsence = (student) => {
		let type = null;
		const item = this.getStudentValue(student);

		if (item.type == "VALID_ABSENCE") {
			type = "INVALID_ABSENCE";
		} else if (item.type == "VALID_LATE") {
			type = "INVALID_LATE";
		} else if (item.type == "INVALID_ABSENCE") {
			type = "VALID_ABSENCE";
		} else if (item.type == "INVALID_LATE") {
			type = "VALID_LATE";
		} else {
			type = 'PRESENT';
		}

		this.setStudentValue(student, type, type.indexOf('INVALID') == -1, item.lateDuration);
	}
	onAbsenceReasonChange = (event, item) => {
		const userValue = this.getStudentValue(item.user);
		this.setStudentValue(item.user, userValue.type, null, userValue.lateDuration, event.target.value);
	}
	onChangeLate = (student) => {
		let type = null;
		const item = this.getStudentValue(student);

		if (item.type == "VALID_ABSENCE") {
			type = "VALID_LATE";
		} else if (item.type == "VALID_LATE") {
			type = "VALID_ABSENCE";
		} else if (item.type == "INVALID_ABSENCE") {
			type = "INVALID_LATE";
		} else if (item.type == "INVALID_LATE") {
			type = "INVALID_ABSENCE";
		} else if (item.type == "OTHER_ACTIVITY") {
			type = "OTHER_ACTIVITY_PARTIAL";
		} else if (item.type == "OTHER_ACTIVITY_PARTIAL") {
			type = "OTHER_ACTIVITY";
		} else {
			type = 'PRESENT';
		}

		this.setStudentValueOtherActivity(student, type, type.indexOf('INVALID') == -1, item.lateDuration);
	}

	renderAbsenceReasons = (item) => {
		const { absenceReasons } = this.props;
		if (absenceReasons == null || absenceReasons.length == 0) {
			return null;
		}
		const value = this.getStudentValue(item.user);

		let defAbsenceReasonId = null;
		if (item.absenceReason != null && item.absenceReason.id != null && item.absenceReason.id > 0) {
			defAbsenceReasonId = item.absenceReason.id;
		}

		return <FormControl variant="standard" sx={{ minWidth: 40 }} size="small">
			<Select style={{ fontSize: '0.8rem' }}
				id={`absence-reason-select-${item.id}`}
				value={value.absenceReason != null ? value.absenceReason.id : defAbsenceReasonId}
				onChange={(event) => this.onAbsenceReasonChange(event, item)}>
				{absenceReasons.map((reason) => {
					return <MenuItem key={reason.id} value={reason.id}>{reason.text}</MenuItem>
				})}
			</Select>
		</FormControl>
	}
	renderHeader() {
		return (
			<tr>
				<th>{this.props.translate('Name')}</th>
				<th>{this.props.translate('absent')}</th>
				<th>{this.props.translate('Minutes')}</th>
				<th>{this.props.translate('mark-for-valid-absence')}</th>
				<th>{this.props.translate('Absence length')}</th>
				<th>{this.props.translate('reported-by')}</th>
				<th>{this.props.translate('reported')}</th>
			</tr>
		);
	}
	renderHeaderOtherActivity() {
		return (
			<tr>
				<th>{this.props.translate('Name')}</th>
				<th>{this.props.translate('present')}</th>
				<th>{this.props.translate('absent')}</th>
				<th>{this.props.translate('late-partly')}</th>
				<th>{this.props.translate('Minutes')}</th>
				{this.props.availableServices.attendanceAbsenceReasons ? <th>{this.props.translate('Note')}</th> : null}
				<th>{this.props.translate('Absence length')}</th>
				<th>{this.props.translate('reported-by')}</th>
				<th>{this.props.translate('reported')}</th>
			</tr>
		);
	}
	renderTable = (items) => {
		const { translate } = this.props;

		if (items == null || items.length == 0) {
			return <div className="color--meta text--center weight--bold">
				{this.props.translate('no-results')}
			</div>
		}

		let students = [];
		items.forEach((item) => {
			item.validAbsent = item.type == "VALID_ABSENCE" || item.type == "VALID_LATE";
			item.absenceReason = item.absenceReason || null;

			// if item.user is not in students, add it
			if (students.findIndex(student => student.userId == item.user.userId) == -1) {
				students.push(item.user);
			}
		});

		return (
			<Table>
				<thead>
					{this.props.availableServices.attendanceAbsenceReasons ?
						this.renderHeaderOtherActivity()
						:
						this.renderHeader()
					}
				</thead>

				<tbody>
					{students.map((student) => {
						const user = new User(student);
						const studentItems = items.filter((item) => item.user.userId == student.userId);
						const value = this.getStudentValue(student);
						let hasHistory = false;

						studentItems.forEach((item) => {
							if (item.history != null && item.history.length > 0) {
								const history = item.history.filter((item) => item.status != 'Deleted');
								hasHistory = history.length > 0;
							}
						});

						return <tr key={student.userId}>
							{/* Name */}
							<td title={student.email} onClick={() => this.onStudentSelect(student)} style={{ cursor: 'pointer' }}>
								{hasHistory ?
									<Icon name="History" />
									: null}

								<DisplayName
									firstName={student.firstName}
									lastName={student.lastName}
									email={student.email}
									data={students}
								/>
							</td>

							{/* Buttons */}
							{this.props.availableServices.attendanceAbsenceReasons ? this.renderUserAbsentActionsOtherActivity(student) : this.renderUserAbsentActions(student)}
							{/* Partial / Late */}
							{this.props.availableServices.attendanceAbsenceReasons ?
								<td style={{ textAlign: 'center', width: 30, verticalAlign: 'top' }}>
									<div style={studentItems.length > 1 ? { marginBottom: 3 } : {}}>
										{value.type != 'PRESENT' ?
											<Checkbox
												value={value.type.indexOf('PARTIAL') > -1 || value.type.indexOf('LATE') > -1}
												onChange={() => { this.onChangeLate(student) }}
											/>
											: null}
									</div>

									{studentItems.length > 1 ?
										studentItems.map((item, index) => {
											return <div key={index} style={{ height: 35 }}>
												<Checkbox
													value={item.type.indexOf('VALID') == 0}
													style={{ float: 'right' }}
													disabled
												/>
											</div>
										})
										: null}
								</td>
								: null}
							{/* Minutes */}
							<td style={{ textAlign: 'center', width: 45, verticalAlign: 'top' }}>
								<div className="form-row">
									{value.type.indexOf('LATE') > -1 || value.type.indexOf('PARTIAL') > -1 ?
										<input
											style={studentItems.length > 1 ? { width: 45, marginBottom: 3 } : { width: 45 }}
											type="number"
											min="0"
											max={this.props.schedule.length}
											value={value.lateDuration}
											onWheel={() => document.activeElement.blur()}
											onChange={e => this.onMinutesChange(e.target.value, student)}
										/>
										:
										<div style={{ width: 60, height: 23, marginBottom: 3 }} />
									}

									{studentItems.length > 1 ?
										studentItems.map((item, index) => {
											if (item.lateDuration == null) {
												return null;
											}

											return <div key={index} style={{ height: 35 }}>
												<input
													style={{ width: 45 }}
													type="number"
													min="0"
													max={this.props.schedule.length}
													value={item.lateDuration}
													disabled
												/>
											</div>
										})
										: null}
								</div>
							</td>

							{/* Valid */}
							{!this.props.availableServices.attendanceAbsenceReasons ?
								<td style={{ textAlign: 'center', width: 30 }}>
									<div style={studentItems.length > 1 ? { marginBottom: 3 } : {}}>
										{value.type != 'PRESENT' && value.type != 'VALID_PRESENT' ?
											<Checkbox
												value={value.valid}
												onChange={() => { this.onChangeValidAbsence(student) }}
											/>
											: null}
									</div>

									{studentItems.length > 1 ?
										studentItems.map((item, index) => {
											return <div key={index} style={{ height: 35 }}>
												<Checkbox
													value={item.type.indexOf('VALID') == 0}
													style={{ float: 'right' }}
													disabled
												/>
											</div>
										})
										: null}
								</td>
								: null}
							{/* Reason */}
							{this.props.availableServices.attendanceAbsenceReasons ?
								<td style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>
									{value.type != 'PRESENT' ?
										this.renderAbsenceReasons(studentItems[0])
										: null}
								</td>
								: null}
							{/* Absence length */}
							<td>
								{studentItems.length == 1 ?
									studentItems[0].reported != null && studentItems[0].endTime != null ?
										<div>
											{translate('From')}: {new DateTime(studentItems[0].startTime).getHourStamp()}<br />
											{translate('To')}: {new DateTime(studentItems[0].endTime).getHourStamp()}
										</div>
										: null
									:
									<div>
										<br />

										{studentItems.map((item, index) => {
											return <div key={index}>
												{translate('From')}: {new DateTime(item.startTime).getHourStamp()}<br />
												{translate('To')}: {new DateTime(item.endTime).getHourStamp()}
												<br />
											</div>
										})}

									</div>
								}
							</td>

							{/* Reported by */}
							<td>
								{studentItems.length == 1 ?
									this.getReportedBy(studentItems[0])
									:
									<div>
										<br />

										{studentItems.map((item, index) => {
											return <div key={index}>
												{this.getReportedBy(item)}

												<br /><br />
											</div>
										})}
									</div>
								}
							</td>

							{/* Reported */}
							<td>
								{studentItems.length == 1 ?
									studentItems[0].reported != null && studentItems[0].reported != "0001-01-01T00:00:00" ?
										new DateTime(studentItems[0].reported).getHourStamp()
										: null
									:
									<div>
										<br />
										{studentItems.map((item, index) => {
											return <div key={index}>
												{item.reported != null ?
													new DateTime(item.reported).getHourStamp()
													: null}

												<br /><br />
											</div>
										})}
									</div>
								}
							</td>

						</tr>
					})}
				</tbody>
			</Table>
		);
	}

	onStudentSelect = (student) => {
		let item = student;
		item.items = [];

		if (this.props.attendance != null) {
			item.items = [...this.props.attendance].filter(attendance =>
				attendance.user.userId == student.userId
			);
		}

		this.setState({ selectedStudent: item });
	}

	deleteAttendance = async () => {
		await this.setState({ loading: true });

		this.props.deleteReportedAttendance(this.props.schedule.id).then(async () => {
			this.props.schedule.attendanceReported = false;
			await this.props.getScheduleItem(this.props.schedule.id);
			await this.props.getForecast(this.props.schedule.id);
			await this.props.getAttendence(this.props.schedule.id);
			await this.props.updateLessonInList(this.props.schedule);
			this.setValues();
		});
	}

	render() {
		const { schedule } = this.props;
		const { selectedStudent } = this.state;
		const reported = schedule.attendanceReported != null;

		if (schedule == null) {
			return null;
		}

		if (this.state.loading) {
			return <Spinner center />
		}

		return (
			<div className="form">
				<Modal
					isOpen={selectedStudent != null}
					title={this.props.translate('Attendance for') + ' ' + selectedStudent?.firstName + ' ' + selectedStudent?.lastName}
					onClose={() => this.setState({ selectedStudent: null })}
					overridePrompt
				>
					<AttendanceHistory student={selectedStudent} />
				</Modal>

				{reported ?
					this.renderTable(this.props.attendance)
					:
					this.renderTable(this.props.forecast)
				}

				<div style={{ marginTop: '1.5rem', marginLeft: '1.7rem' }}>
					{reported ?
						<Button type="save" onClick={this.onSubmit}>
							{this.state.submitting ?
								<Spinner center small />
								: null}

							{reported ?
								this.props.translate('update-report')
								:
								this.props.translate('save-report')
							}
						</Button>
						: null}

					{!reported && this.props.forecast ?
						<Button type="save" onClick={this.onSubmit}>
							{this.state.submitting ?
								<Spinner center small />
								: null}

							{reported ?
								this.props.translate('update-report')
								:
								this.props.translate('save-report')
							}
						</Button>
						: null}

					{reported ?
						<Button type="secondary" style={{ marginLeft: '1rem' }} onClick={this.deleteAttendance}>
							{this.state.submitting ?
								<Spinner />
								: null}

							{this.props.translate('Remove report')}
						</Button>
						: null}
				</div>

				<ReportHistory attendance={this.props.attendance} />
			</div>
		);
	}

}

function mapStateToProps(state) {
	return {
		user: state.user.currentUser,
		attendance: state.Absence.calendarAttendence,
		translate: translate(state.Languages.translations),
		forecast: state.Absence.forecast,
		schedule: state.schedule.activeScheduleItem,
		availableServices: state.Services.availableServices,
		absenceReasons: state.Absence.absenceReasons,
	};
};

export default connect(mapStateToProps, {
	getAttendence,
	getForecast,
	getAbsenceReasons,
	deleteReportedAttendance,
	getScheduleItem,
	updateLessonInList,
})(UserAbsence);
